import axios from "axios";
import FileSaver from 'file-saver';

import { authIsMissing } from "./auth";

export const FETCH_QUEUE_DATA = "QUEUE/FETCH_QUEUE_DATA";
export const FETCH_QUEUE_DATA_SUCCESS = "QUEUE/FETCH_QUEUE_DATA_SUCCESS";
export const FETCH_QUEUE_DATA_FAILED = "QUEUE/FETCH_QUEUE_DATA_FAILED";

export const FETCH_QUEUE_XLS = "QUEUE/FETCH_QUEUE_XLS";
export const FETCH_QUEUE_XLS_SUCCESS = "QUEUE/FETCH_QUEUE_XLS_SUCCESS";
export const FETCH_QUEUE_XLS_FAILED = "QUEUE/FETCH_QUEUE_XLS_FAILED";

export const SET_SENDER = "QUEUE/SET_SENDER";
export const CLEAR_ERRORS = "QUEUE/CLEAR_ERRORS";

const initialState = {
  loading: false,
  data: [],
  error: null,
  sender: "",
  pages: -1,
  pageSize: 20,
  fetchingXls: false,
};

export const setSender = (sender) => {
  return {
    type: SET_SENDER,
    sender,
  };
};

let abortController; // Module scoped abort controller
export const fetchData = (dispatch) => (
  sender,
  page,
  pageSize,
  domain
) => {
  dispatch({
    type: FETCH_QUEUE_DATA,
  });

  const accessToken = sessionStorage.getItem("accessToken");
  if (
    accessToken === null ||
    accessToken === "" ||
    accessToken === "undefined"
  ) {
    sessionStorage.removeItem("accessToken");
    return dispatch(authIsMissing());
  }
  let params = {
    sender,
    page,
    pageSize,
  };

  if (!!domain && domain !== -1) {
    params["domainId"] = domain;
  }

  if (abortController) {
    abortController.abort(); // Tell the browser to abort request
  }
  abortController = typeof 'AbortController' !== 'undefined' && new AbortController();

  return axios
    .get(`${process.env.REACT_APP_API_HOST}/queue`, {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      signal: abortController.signal,
    })
    .then((res) => {
      const queueData = res.data.data.results.map((row, idx) => {
        return { ...row, rowIndex: idx };
      });
      return dispatch({
        type: FETCH_QUEUE_DATA_SUCCESS,
        data: queueData,
        pages: res.data.data.pageCount,
        pageSize: res.data.data.pageSize,
      });
    })
    .catch((err) => {
      if (
        err !== undefined &&
        err.response !== undefined &&
        err.response.status === 401
      ) {
        // lets authenticate again
        sessionStorage.removeItem("accessToken");
        return dispatch(authIsMissing());
      }
      return dispatch({
        type: FETCH_QUEUE_DATA_FAILED,
        error: err,
      });
    });
};


export const fetchXls = (dispatch) => (
  sender,
  domain
) => {
  dispatch({
    type: FETCH_QUEUE_XLS,
  });

  const accessToken = sessionStorage.getItem("accessToken");
  if (
    accessToken === null ||
    accessToken === "" ||
    accessToken === "undefined"
  ) {
    sessionStorage.removeItem("accessToken");
    return dispatch(authIsMissing());
  }
  let params = {
    sender,
    export: 1
  };

  if (!!domain && domain !== -1) {
    params["domainId"] = domain;
  }

  return axios
    .get(`${process.env.REACT_APP_API_HOST}/queue`, {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob',
    })
    .then((res) => {

      FileSaver.saveAs(res.data, "queue.csv");

      return dispatch({
        type: FETCH_QUEUE_XLS_SUCCESS,
      });
    })
    .catch((err) => {
      if (
        err !== undefined &&
        err.response !== undefined &&
        err.response.status === 401
      ) {
        // lets authenticate again
        sessionStorage.removeItem("accessToken");
        return dispatch(authIsMissing());
      }
      return dispatch({
        type: FETCH_QUEUE_XLS_FAILED,
        error: err,
      });
    });
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      }; 
    case FETCH_QUEUE_DATA:
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    case FETCH_QUEUE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        pages: action.pages,
        error: null,
      };
    case FETCH_QUEUE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error,
      };
    case FETCH_QUEUE_XLS:
      return {
        ...state,
        fetchingXls: true,
      };
    case FETCH_QUEUE_XLS_SUCCESS:
      return {
        ...state,
        fetchingXls: false,
      };
    case FETCH_QUEUE_XLS_FAILED:
      return {
        ...state,
        fetchingXls: false,
      };
    case SET_SENDER:
      return {
        ...state,
        sender: action.sender,
      };

    default:
      return state;
  }
};
